import React, { useEffect } from "react";
import NavBar from "../components/NavBar.jsx";
import "../styles/bespoke.css";

export default function LegalNotice({ onNavigate }) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Legal Notice | AskMax Security";
    return () => { document.title = previousTitle; };
  }, []);

  const contact = () => onNavigate("/bespoke", { section: "contact" });

  return (
    <>
      <NavBar mode="legal" onNavigate={onNavigate} onSelectService={contact} />
      <main className="bespoke-page legal-notice">
        <section className="bespoke-page__section container" aria-labelledby="legal-notice-title">
          <p className="bespoke-page__eyebrow">AskMax Security</p>
          <h1 id="legal-notice-title">Mentions l&eacute;gales / Legal Notice</h1>
          <p>AskMax Security is the trading name of INCOGNITO CYBER ESSENTIALS SAS, a company registered in France.</p>
          <p role="note">The Netlify telephone number has been verified by Stephen McCormack.</p>
        </section>
        <section className="bespoke-page__section container" aria-labelledby="legal-company-title">
          <h2 id="legal-company-title">Company identification</h2>
          <dl className="legal-notice__details">
            <dt>Trading name</dt><dd>AskMax Security</dd>
            <dt>Legal entity</dt><dd>INCOGNITO CYBER ESSENTIALS SAS</dd>
            <dt>Legal form</dt><dd>Soci&eacute;t&eacute; par Actions Simplifi&eacute;e (SAS)</dd>
            <dt>Registered office</dt><dd>4 Rue de la Cloche d&apos;Or, 66000 Perpignan, France</dd>
            <dt>SIREN</dt><dd>927 558 684</dd>
            <dt>SIRET</dt><dd>927 558 684 00019</dd>
            <dt>RCS</dt><dd>Perpignan 927 558 684</dd>
            <dt>Share capital</dt><dd>&euro;100</dd>
            <dt>APE/NAF</dt><dd>6202A</dd>
            <dt>President</dt><dd>Stephen McCormack</dd>
            <dt>Company creation</dt><dd>2 April 2024</dd>
            <dt>RCS registration</dt><dd>11 April 2024</dd>
            <dt>Telephone</dt><dd><a href="tel:+33788825004">+33 7 88 82 50 04</a></dd>
            <dt>Email</dt><dd><a href="mailto:stephen@askmaxsecurity.com">stephen@askmaxsecurity.com</a></dd>
          </dl>
          <p>Company details above were supplied and verified by the company representative. No independent registry verification is claimed.</p>
        </section>
        <section className="bespoke-page__section container" aria-labelledby="legal-publication-title">
          <h2 id="legal-publication-title">Publication director</h2>
          <p>Stephen McCormack, President.</p>
        </section>
        <section className="bespoke-page__section container" aria-labelledby="legal-hosting-title">
          <h2 id="legal-hosting-title">Hosting</h2>
          <p>Hosting platform: Netlify. Netlify&apos;s Data Processing Agreement identifies the provider as Netlify, Inc.</p>
          <dl className="legal-notice__details">
            <dt>Hosting company</dt><dd>Netlify, Inc.</dd>
            <dt>Address</dt><dd>101 2nd Street, San Francisco, CA 94105, United States</dd>
            <dt>Telephone</dt><dd><a href="tel:+14156911573">+1 415 691 1573</a></dd>
            <dt>Support</dt><dd><a href="mailto:support@netlify.com">support@netlify.com</a></dd>
            <dt>Legal contact</dt><dd><a href="mailto:legal@netlify.com">legal@netlify.com</a></dd>
          </dl>
          <p>Netlify&apos;s published materials list the company, address and support contact. Stephen McCormack verified the hosting telephone number. The legal email above was supplied by Stephen and has not been independently verified.</p>
          <ul>
            <li><a href="https://www.netlify.com/legal/terms-of-use/" target="_blank" rel="noreferrer">Netlify website terms, contact information</a></li>
            <li><a href="https://www.netlify.com/privacy/" target="_blank" rel="noreferrer">Netlify privacy statement</a></li>
            <li><a href="https://www.netlify.com/pdf/netlify-dpa.pdf" target="_blank" rel="noreferrer">Netlify Data Processing Agreement, Annex 1</a></li>
          </ul>
        </section>
        <section className="bespoke-page__section container" aria-labelledby="legal-privacy-title">
          <h2 id="legal-privacy-title">Privacy contact</h2>
          <p>Privacy enquiries may be addressed to INCOGNITO CYBER ESSENTIALS at the registered office or contact email above. See the <a href="/privacy/" onClick={(event) => { event.preventDefault(); onNavigate("/privacy"); }}>Privacy Notice</a>.</p>
        </section>
      </main>
      <footer className="bespoke-page__footer"><div className="container bespoke-page__footer-row"><a href="/" onClick={(event) => { event.preventDefault(); onNavigate("/"); }}>AskMax Security home</a><a href="/privacy/" onClick={(event) => { event.preventDefault(); onNavigate("/privacy"); }}>Privacy Notice</a><span>INCOGNITO CYBER ESSENTIALS</span></div></footer>
    </>
  );
}